<template>
  <div id="panel-left" class="panel-left" :class="{ collapsed }">
    <div class="timeline-header">
      <span v-show="!collapsed">📅 Timeline</span>
      <button
        class="collapse-toggle"
        :class="{ 'is-collapsed': collapsed }"
        @click="collapsed = !collapsed"
        :title="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 6 9 12 15 18" />
        </svg>
      </button>
    </div>

    <template v-if="!collapsed">
      <div class="timeline-search">
        <div class="search-box">
          <span style="font-size: 12px; opacity: 0.4">🔍</span>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Cari bulan, tahun..."
          />
          <button
            v-show="searchQuery"
            class="clear-btn"
            @click="clearSearch"
          >×</button>
        </div>
        <div
          v-show="searchQuery.trim()"
          class="search-results-count"
        >{{ searchResultsCount }} hasil</div>
      </div>

      <div class="timeline-controls">
        <button class="ctrl-btn" @click="expandAll" title="Buka semua bulan">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
          Buka
        </button>
        <button class="ctrl-btn" @click="collapseAll" title="Tutup semua bulan">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="18 15 12 9 6 15" />
          </svg>
          Tutup
        </button>
      </div>

      <div class="timeline-tree">
        <template v-if="filteredTimeline.length">
          <template v-for="month in filteredTimeline" :key="month.key">
            <button
              class="month-btn"
              :class="{ active: expandedMonths[month.key] }"
              @click="toggleMonth(month.key)"
            >
              <span class="month-arrow">▶</span>
              {{ month.label }}
              <span class="month-count">{{ month.days.length }}d</span>
            </button>

            <div v-show="expandedMonths[month.key]" class="month-days">
              <button
                v-for="day in month.days"
                :key="day.date"
                class="day-btn"
                :class="{
                  selected: selectedDate === day.date,
                  today: day.isToday,
                  'has-analysis': day.hasAnalysis,
                }"
                @click="selectDate(day.date)"
              >
                <span class="day-dot"></span>
                <span>{{ day.label }}</span>
                <span v-if="day.isToday" class="now-badge">NOW</span>
                <span v-else-if="day.hasAnalysis" class="analysis-badge">✓</span>
              </button>
            </div>
          </template>
        </template>

        <div
          v-else
          style="padding: 20px; text-align: center; color: var(--text-faint); font-size: 11px"
        >
          Memuat data...
        </div>
      </div>
    </template>

    <!-- Collapsed: vertical label -->
    <div v-else class="collapsed-label">
      <span>T</span><span>I</span><span>M</span><span>E</span><span>L</span><span>I</span><span>N</span><span>E</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useTimeline } from '../composables/useTimeline'

const collapsed = ref(false)

const {
  selectedDate,
  expandedMonths,
  searchQuery,
  filteredTimeline,
  searchResultsCount,
  toggleMonth,
  collapseAll,
  expandAll,
  selectDate,
  clearSearch,
} = useTimeline()
</script>
